import { combineReducers } from 'redux'
import user from './user'
import home from './home'
import bind from './bind'
import auth from './auth'
import config from './config'
const reducer = combineReducers({
  user,
  home,
  bind,
  auth,
  config
})
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/index.tsx